import {
  PlaySoundAction,
  ReelsEngine,
  ReelsSoundModel,
  StopSoundAction,
  WaitForAction,
  CollapsingSpinConfig,
  FastSpinsComponent,
  FAST_SPINS_COMPONENT,
} from '@cgs/machines';
import { BuildAction } from '@cgs/shared';
import {
  Container,
  EmptyAction,
  FunctionAction,
  IntervalAction,
  ParallelAction,
  SequenceAction,
} from '@cgs/wge';

export class SantaFreeFallStopAction extends BuildAction {
  private _reelsEngine: ReelsEngine;
  private _winTapes: number[][];
  private _collapsingSpinConfig: CollapsingSpinConfig;
  private _reelSounds: ReelsSoundModel;
  private _reelsDelay: number[];
  private fastSpinsComponent: FastSpinsComponent;

  constructor(
    container: Container,
    reelsEngine: ReelsEngine,
    winTapes: number[][],
    reelSounds: ReelsSoundModel,
    collapsingSpinConfig: CollapsingSpinConfig
  ) {
    super();
    this._reelsEngine = reelsEngine;
    this._winTapes = winTapes;
    this._reelSounds = reelSounds;
    this._collapsingSpinConfig = collapsingSpinConfig;

    this.fastSpinsComponent = container.resolve<FastSpinsComponent>(FAST_SPINS_COMPONENT);
  }

  buildAction(): IntervalAction {
    const actions: IntervalAction[] = [];
    this._reelsDelay = this.fastSpinsComponent.isFastSpinsActive
      ? new Array(this._reelsEngine.ReelConfig.reelCount).fill(0)
      : this._collapsingSpinConfig.collapsingParameters!.fallStopDelays;

    const fallingSound = this._reelSounds.getSoundByName('spin_stop');
    const fallingFastSpinSound = this._reelSounds.getSoundByName('fast_spin_stop');

    actions.push(
      this.fastSpinsComponent.isFastSpinsActive
        ? new StopSoundAction(fallingFastSpinSound)
        : new StopSoundAction(fallingSound)
    );

    actions.push(
      this.fastSpinsComponent.isFastSpinsActive
        ? new PlaySoundAction(fallingFastSpinSound)
        : new PlaySoundAction(fallingSound)
    );

    for (let reel = 0; reel < this._reelsEngine.ReelConfig.reelCount; ++reel) {
      actions.push(this._stop(reel, this._winTapes[reel]));
    }
    actions.push(new WaitForAction(this._reelsEngine.slotsStoped));
    return new ParallelAction(actions);
  }

  private _stop(reel: number, winTapes: number[]): IntervalAction {
    const actions: IntervalAction[] = [];
    actions.push(new EmptyAction().withDuration(this._reelsDelay[reel]));

    for (let line = this._reelsEngine.ReelConfig.lineCount - 1; line >= 0; --line) {
      actions.push(
        new FunctionAction(() => this._reelsEngine.stopEntity(reel, line, winTapes[line]))
      );
      actions.push(
        new ParallelAction([
          new EmptyAction().withDuration(
            this._collapsingSpinConfig.collapsingParameters!.iconOutgoingStartDelay
          ),
          new SequenceAction([
            new EmptyAction().withDuration(
              this._collapsingSpinConfig.collapsingParameters!.iconOutgoingStartDelay * 0.5
            ),
            new FunctionAction(() => {
              const isScatter = winTapes[line] == 1;
              if (isScatter) {
                const entity = this._reelsEngine.getReelStoppedEntities(reel, line)[0];
                this._reelsEngine.startAnimation(entity, 'anticipation');
              }
            }),
          ]),
        ])
      );
    }

    return new SequenceAction(actions);
  }
}
